import React from "react";
import { useI18n } from "../i18n";
import { properties } from "../data/properties";
import { PropertyCard } from "../components/PropertyCard";
import { imgProxy } from "../lib/imgProxy";

export default function PropertiesPage() {
  const { t } = useI18n();
  return (
    <main>
      <section className="relative h-[48vh] min-h-[380px] flex items-center hero-bg">
        <div className="hero-img" style={{ backgroundImage: `url('${imgProxy("https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/7n3305k5_Chamonix-Mont-Blanc.jpg", { w: 2000, q: 78 })}')` }} />
        <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 text-white">
          <p className="text-[11px] uppercase tracking-[.3em] opacity-90 mb-4">MyHost · Chamonix</p>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-tight" data-testid="properties-title">{t.properties.title}</h1>
          <p className="mt-4 opacity-90 max-w-xl">{t.properties.subtitle}</p>
        </div>
      </section>

      <section className="py-20 max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="properties-grid">
          {properties.map((p) => <PropertyCard key={p.id} property={p} />)}
        </div>
      </section>
    </main>
  );
}
